import { CookieMonster } from 'root/utils/cookies/cookieMonster';

const Lightbox = (function () {
    var body,
        markup = {
            parent: null,
            lightbox: null,
            overlay: null,
            box: null,
            safe: null,
            close: null,
        },
        // parse the options passed on construct and assign default if none passed
        _setOptions = function _setOptions(options, defaults) {
            if (typeof options === 'object') {
                for (var key in defaults) {
                    if (!Object.prototype.hasOwnProperty.call(defaults, key)) {
                        continue;
                    }
                    options[key] =
                        typeof options[key] === 'undefined'
                            ? defaults[key]
                            : options[key];
                }
                return options;
            }
        },
        // type check utility
        _check = function _check(value, type) {
            return typeof value === type;
        },
        // element type check utility
        _isDOMElement = function _isDOMElement(object) {
            if (object !== null) {
                return object.nodeType === Node.ELEMENT_NODE;
            }
            return false;
        },
        // callback utility
        _doCallback = function _doCallback(fn, arg) {
            if (_check(fn, 'function')) {
                fn(arg);
            }
        },
        // create and get the elements needed
        _createLightbox = function _createLightbox(markup, constructor) {
            body = document.querySelector('body');
            markup.parent = document.querySelector(constructor.options.parentSelector);
            markup.lightbox = document.createElement('div');
            markup.overlay = document.createElement('div');
            markup.box = document.createElement('div');
            markup.safe = document.createElement('div');
            markup.close = document.createElement('div');
        },
        // check if appending text or an html element
        _setLightboxContent = function _setLightboxContent(markup, constructor) {
            if (_check(constructor.content, 'string')) {
                var p = document.createElement('p');
                p.classList.add(constructor.options.textContentClass);
                p.textContent = constructor.content;

                markup.safe.appendChild(p);
            } else if (_isDOMElement(constructor.content)) {
                markup.safe.appendChild(constructor.content);
            }
        },
        // sets all the attributes to the constructed lightbox
        _setLightboxAttributes = function _setLightboxAttributes(markup, constructor) {
            var value;

            for (var piece in markup) {
                if (Object.prototype.hasOwnProperty.call(markup, piece)) {
                    if (piece === 'lightbox' && constructor.options.name !== '') {
                        value = constructor.options.name;
                    } else {
                        value = '';
                    }
                    markup[piece].setAttribute(
                        constructor.options.attributeNamespace + '-' + piece,
                        value
                    );
                }
            }
        },
        // sets all styles to the constructed lightbox
        _setLightboxStyles = function _setLightboxStyles(markup, constructor) {
            if (_check(constructor.options.overlayBGColor, 'string')) {
                markup.overlay.style.backgroundColor = constructor.options.overlayBGColor;
            }

            if (constructor.options.closeOnContentClick) {
                markup.box.style.cursor = 'pointer';
            }
        },
        // compose the lightbox with all elements
        _assembleLightbox = function _assembleLightbox(markup) {
            markup.box.appendChild(markup.close);
            markup.box.appendChild(markup.safe);
            markup.lightbox.appendChild(markup.box);
            markup.lightbox.appendChild(markup.overlay);
        },
        // appends the lightbox to its parent
        _appendLightbox = function _appendLightbox(markup) {
            markup.parent.appendChild(markup.lightbox);
        },
        // animates the lightbox
        _animateLightbox = function _animateLightbox(markup, constructor) {
            var _addClass = function _addClass() {
                markup.box.classList.add(constructor.options.boxAnimationClass);
            };

            setTimeout(_addClass, 240);
        },
        // compute the lightbox
        _initLightbox = function _initLightbox(markup, constructor) {
            _createLightbox(markup, constructor);
            _setLightboxContent(markup, constructor);

            if (
                _isDOMElement(constructor.content) ||
                _check(constructor.content, 'string')
            ) {
                _setLightboxAttributes(markup, constructor);
                _setLightboxStyles(markup, constructor);
                _assembleLightbox(markup);
                _appendLightbox(markup);
                _animateLightbox(markup, constructor);
            }
        },
        // bind all needed listeners for the lightbox
        _bindListeners = function _bindListeners(markup, constructor) {
            markup.close.addEventListener('click', function () {
                constructor.hide();
            });
            markup.overlay.addEventListener('click', function () {
                constructor.hide();
            });

            if (constructor.options.closeOnContentClick) {
                markup.box.addEventListener('click', function () {
                    constructor.hide();
                });
            }
        },
        constructor = function constructor(content, options) {
            this.content = content;
            this.options = _setOptions(options, this.defaults);

            _doCallback(this.options.onConstructCallback, this);
        };

    constructor.prototype = {
        defaults: {
            name: '',
            parentSelector: 'body',
            overlayBGColor: false,
            cookie: false,
            cookieValue: true,
            cookieDuration: 30,
            attributeNamespace: 'data-lightbox',
            visibilityClass: 'lightbox-visible',
            boxAnimationClass: 'lightbox-box-animate',
            textContentClass: 'lightbox-text-content',
            closeOnContentClick: false,
            onConstructCallback: false,
            onInitCallback: false,
            onShowCallback: false,
            onHideCallback: false,
        },
        show: function () {
            body.classList.add(this.options.visibilityClass);
            _doCallback(this.options.onShowCallback, this);
        },
        hide: function () {
            body.classList.remove(this.options.visibilityClass);

            if (_check(this.options.cookie, 'string')) {
                this.setCookie(
                    this.options.cookie,
                    this.options.cookieValue,
                    this.options.cookieDuration
                );
            }

            _doCallback(this.options.onHideCallback, this);
        },
        setContent: function (content) {
            _setLightboxContent(markup.safe, content);
        },
        init: function () {
            if (!this.getCookie(this.options.cookie)) {
                _initLightbox(markup, this);
                _bindListeners(markup, this);

                this.show();
            }

            _doCallback(this.options.onInitCallback, this);
        },
    };

    // add cookie functionality through prototype
    CookieMonster.call(constructor.prototype);

    return constructor;
})();

export { Lightbox as default };
